import React, { useEffect } from "react";

import styles from "../style.module.css";

import icon from "../../assets/image/Frame.png";
import bold from "../../assets/image/boldx.jpg";

const REDIRECT_URI = process.env.REACT_APP_REDIRECT_URI;

function Yandex() {
  useEffect(() => {
    window.YaAuthSuggest.init(
      {
        client_id: "26cc72fd466f4403a111657746c9dbcf",
        response_type: "token",
        redirect_uri: REDIRECT_URI,
      },
      REDIRECT_URI,
      {
        view: "button",
        parentId: "buttonContainerId",
        buttonSize: "m",
        buttonView: "main",
        buttonTheme: "light",
        buttonBorderRadius: "18",
        buttonIcon: "ya",
      },
    )
      .then(async function (result) {
        return await result.handler();
      })
      .then(function (data) {
        console.log("Сообщение с токеном: ", data);
      })
      .catch(function (error) {
        console.log("Что-то пошло не так: ", error);
      });
  }, []);

  return (
    <div className={styles.load}>
      <img className={styles.load__logo_bold} src={bold} alt="Logo" />
      <div className={styles.load__logo_container}>
        <img className={styles.load__logo} src={icon} alt="Logo" />
        <div>
          <h2>Fire Safety</h2>
          <p>Center</p>
        </div>
      </div>
      <div className={styles.load__cpb}>
        <h3 className={styles.load__cpb__title}>CPBZero</h3>
      </div>
      <span
        style={{ position: "absolute", bottom: "100px", width: "90%" }}
        id="buttonContainerId"
      ></span>
    </div>
  );
}

export default Yandex;
